
export default {
    name: 'ScheduleMemo',

    props: {
        memos: Array,
    },
    data() {
        return {}
    },
    methods: {
        onClickitem(id) {
            const el = document.getElementById(id)
            if (el.style.display === 'table-row') {
                el.style.display = 'none'
            } else {
                el.style.display = 'table-row'
            }
        },
    },
}
